/**
 * The path prefix the app is served under, in the shape history wants.
 *
 * Vite supplies its `--base` as `import.meta.env.BASE_URL`, always with a trailing
 * slash. history strips `basename` off a path by length, so that trailing slash
 * would eat the leading slash of every route and match nothing. At the root that
 * leaves "", which is history's own default for an unprefixed app.
 *
 * @param {string|undefined} baseUrl Vite's BASE_URL, e.g. "/lender/abc1234/"
 * @returns {string} "" at the root, otherwise "/lender/abc1234"
 */
export function routerBasename(baseUrl) {
  return (baseUrl || '/').replace(/\/+$/, '')
}
